import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import Category from "../components/side-category"

import SEO from "../components/seo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHome, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"

export const query = graphql`
  query($skip: Int!, $limit: Int!)  {
    allContentfulBlogPost(
      sort: { order: DESC, fields: publishDate }
      skip: $skip
      limit: $limit
    ) {
      edges {
        node {
          title
          id
          slug
          eyecatch {
            fluid(maxWidth: 400) {
              ...GatsbyContentfulFluid_withWebp
            }
            description
          }
        }
      }
    }
  }
`

export default ({ data, location, pageContext }) => (
  <Layout>
    <SEO
      pagetitle="ブログ"
      pagedesc="ESSENTIALSのブログです"
      pagepath={location.pathname}
    />

    <div className="blog-Body_Main">
      <div className="blog-Body_Container">

        <section className="blog-Posts">
          <div className="blog-Posts_Inner">
            <div className="blog-Posts_Head">
              <div className="blog-Posts_HomeLink"><Link to={'/'}><FontAwesomeIcon icon={faHome} />Home</Link></div>
              <h1 className="blog-Posts_Title">すべての記事</h1>
            </div>
            <div className="blog-Posts_Lists">
              {data.allContentfulBlogPost.edges.map(({ node }) => (
                <article className="blog-Posts_Post" key={node.id}>
                  <Link to={`/blog/post/${node.slug}/`}>
                    <figure className="blog-Posts_PostImg">
                      <Img
                        fluid={node.eyecatch.fluid}
                        alt={node.eyecatch.description}
                        style={{ height: "100%" }}
                      />
                    </figure>
                    <div className="blog-Posts_Info">
                      <h3 className="blog-Posts_PostTitle">{node.title}</h3>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
            <ul className="blog-Posts_Pagenation">
              {!pageContext.isFirst && (
                <li className="blog-Posts_PageLink prev">
                  <Link
                    to={
                      pageContext.currentPage === 2
                        ? `/blog/`
                        : `/blog/${pageContext.currentPage - 1}/`
                    }
                    rel="prev"
                  >
                    <FontAwesomeIcon icon={faChevronLeft} />
                    <span>前のページ</span>
                  </Link>
                </li>
              )}
              {!pageContext.isLast && (
                <li className="blog-Posts_PageLink next">
                  <Link to={`/blog/${pageContext.currentPage + 1}/`} rel="next">
                    <span>次のページ</span>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </section>

        <section class="blog-Side">
          <div className="blog-Side_Inner">
            <div className="blog-Side_Block">
              <h2 className="blog-Side_Title">Category</h2>
              <div className="blog-Side_Content">
                <Category />
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>

  </Layout>
)